<template>
  <div class="pl-8 pr-3 w-full h-full">
    <div class="flex flex-row items-center gap-3 mb-3">
      <button
        @click="setActiveSubMenu('Tool')"
        class="flex flex-row justify-center items-center w-4 h-4 bg-gray-400 rounded-md"
        title="Kembali ke menu tool">
        <i class="material-icons text-lg text-white">chevron_left</i>
      </button>
      <h1 class="flex flex-col">
        <span class="text-sm text-white mr-1 font-bold">List Laporan</span>
        <i class="text-xs text-white">(daftar semua laporan yang telah dibuat)</i>
      </h1>
    </div>
    <TableReports />
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import TableReports from './TableReports.vue'

export default {
  name: 'ToolReports',
  components: {
    TableReports
  },
  methods: {
    ...mapActions(['toShowLargeMenu']),
    ...mapMutations(['setActiveSubMenu'])
  },
  mounted: function () {
    this.toShowLargeMenu()
  }
}
</script>
